/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export interface paths {
  "/api/v1/events": {
    post: {
      parameters: {
        header: {
          /** Индикатор того, одно или несколько событий шлем. Если bulk то в запросе payload будет массив событий, single - одно событие */
          "X-Action"?: "bulk" | "single";
        };
      };
      responses: {
        /** Success response */
        200: {
          content: {
            "application/json": components["schemas"]["EventResponse"];
          };
        };
        /** Error Response */
        400: {
          content: {
            "application/json": components["schemas"]["EventResponse"];
          };
        };
        /** Error Response */
        422: {
          content: {
            "application/json": components["schemas"]["EventResponse"];
          };
        };
      };
      requestBody: components["requestBodies"]["EventInput"];
    };
  };
}

export interface components {
  schemas: {
    EventResponse:
      | components["schemas"]["EventResponseItem"]
      | components["schemas"]["EventResponseItem"][];
    EventResponseItem: {
      /** @example 200 */
      code?: number;
      errors?: components["schemas"]["EventResponseItem_errors"];
    };
    _api_v1_events_post_request: {
      /**
       * @description Event Name
       * @example event_name
       */
      name: string;
      /** @example 73b3678c-e9c1-4845-897f-4d3f01b08816 */
      device_id: string;
      /** @example text_changed */
      category: string;
      /** @example 2 */
      platform_id: number;
      /** @example 3.0.2 */
      app_version?: string;
      /** @description Относится данное событие к техническому или бизнесовому событию */
      technical_logs?: boolean;
      /** @example {"key":"val", "key2": 2, "key3": true} */
      parameters?: { [key: string]: string };
      /** Format: float */
      value?: number;
      /**
       * Format: int64
       * @description серверное время (на серверах MS Events), когда производилась обработка поступившего от клиента ивента/батча ивентов это поле проставляет data platform при обработке ивента. UNIX (GMT)
       * @example 1488383103000
       */
      server_time?: number;
      /**
       * Format: int64
       * @description системное время (устройства) в миллисекундах в момент события, которое описывает. Может быть некорректным. UNIX (GMT)
       * @example 1488383102666
       */
      client_time?: number;
      /**
       * Format: int64
       * @description время сервера в миллисекундах в момент события, которое описывает (используется для аналитики
       * @example 1488383102666
       */
      sync_time?: number;
      /**
       * Format: uuid
       * @description UUID генерируется для каждого уникального ивента, переиспользуется при повторной отправке, чтобы избежать дубликатов при обработке
       * @example 123e4567-e89b-12d3-a456-426655440000
       */
      uuid?: string;
    };
    EventResponseItem_errors: string | { [key: string]: string };
  };
  requestBodies: {
    EventInput: {
      content: {
        "application/json": components["schemas"]["_api_v1_events_post_request"];
      };
    };
  };
}

export interface operations {}

export interface external {}

export enum ApiPaths {
  PostApiV1Events = "/api/v1/events",
}
